import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";
import { SubsegmentQueryType } from "@reflag/shared/featureAPI";
import { FeatureFeedbackHistogram } from "@reflag/shared/featureFeedbackAPI";

import { featureQueryKeys } from "./featureQueryKeys";

export function useFeatureFeedbackHistogramData(
  featureId?: string,
  params?: SubsegmentQueryType,
) {
  const { appId, envId } = useEnvironment();

  return useQuery<FeatureFeedbackHistogram, AxiosResponse<ErrorResponse>>({
    queryKey: featureQueryKeys.singleFeatureFeedbackHistogram(
      appId,
      envId,
      featureId,
      params,
    ),

    queryFn: () =>
      api
        .get<"/apps/:appId/features/:featureId/feedback/histogram">(
          `/apps/${appId}/features/${featureId}/feedback/histogram`,
          {
            params: {
              ...params,
              envId: envId!,
            },
          },
        )
        .then((res) => res.data),
    enabled: !!appId && !!envId && !!featureId,
  });
}
